import * as React from "react";
import { Outlet } from "react-router-dom";
import type { TransactionDetails } from "src/providers/transaction-provider";
import TransactionsList from "./transactions-list";

export type TransactionsOutletContext = {
	transactions: TransactionDetails[];
	isLoading: boolean;
};

const TransactionsLayout: React.FC = () => {
	const [transactions, setTransactions] = React.useState<TransactionDetails[]>(
		[],
	);
	const [totalCount, setTotalCount] = React.useState(0);
	const [isLoading, setIsLoading] = React.useState(true);

	return (
		<>
			<TransactionsList
				transactions={transactions}
				totalCount={totalCount}
				isLoading={isLoading}
				setTransactions={setTransactions}
				setTotalCount={setTotalCount}
				setIsLoading={setIsLoading}
			/>
			<Outlet context={{ transactions, isLoading }} />
		</>
	);
};

export default TransactionsLayout;
